import clsx from 'clsx';
import React from 'react';

/**
 * The only place server-rendered HTML is shown: an empty sandbox, so the
 * document cannot script, navigate, or reach the app around it.
 * `note` says whose document this is — pass the caller's wording, or null for
 * no caption.
 */
export const PreviewFrame: React.FC<{
  html: string;
  title?: string;
  height?: number;
  note?: React.ReactNode;
  className?: string;
}> = ({
  html,
  title = 'Preview',
  height = 560,
  note = 'Rendered by the server and shown in an isolated frame.',
  className,
}) => (
  <div
    className={clsx('border-t border-v2-line bg-v2-sunken/40 p-3', className)}
  >
    <iframe
      title={title}
      sandbox=""
      srcDoc={html}
      style={{ height }}
      className="w-full rounded-v2 border border-v2-line bg-white"
    />
    {note && <p className="mt-1.5 text-v2-11 text-v2-fg-4">{note}</p>}
  </div>
);
